/** sessionStorage: Help → start tour after navigating to /projects */
export const PRODUCT_TOUR_SESSION_PENDING = 'mm_product_tour_pending'

/**
 * Sent in `summary_user_instructions` while the product tour is active so the API returns
 * deterministic mock snapshots. Must match `backend.constants.product_tour.TOUR_MOCK_GENERATION_MARKER`.
 */
export const TOUR_MOCK_GENERATION_MARKER = '__MM_TOUR_MOCK_GENERATION_V1__' as const

/** Stable `data-tour` attribute values for the product tour */
export const TOUR = {
	newProject: 'new-project',
	projectCreateModal: 'project-create-modal',
	projectCreate: 'project-create',
	projectTile: 'project-tile',
	analysesSection: 'analyses-section',
	filesCard: 'files-card',
	importFile: 'import-file',
	pasteText: 'paste-text',
	pasteModal: 'paste-modal',
	pasteSubmit: 'paste-submit',
	pasteTextarea: 'paste-textarea',
	startAnalysis: 'start-analysis',
	artifactReady: 'artifact-ready',
	analysisModal: 'analysis-modal',
	modalContextContinue: 'modal-context-continue',
	modalTemplateContinue: 'modal-template-continue',
	modalSummaryContinue: 'modal-summary-continue',
	modalGenerate: 'modal-generate',
	modalPrimaryFirst: 'modal-primary-first',
	summaryRegenerate: 'summary-regenerate',
	summaryChat: 'summary-chat',
	summaryGoToModel: 'summary-go-to-model',
	analysisStepperNext: 'analysis-stepper-next',
	analysisStatusIndicator: 'analysis-status-indicator',
	generatingSummaryContent: 'generating-summary-content',
	bpmnToolbar: 'bpmn-toolbar',
	bpmnCanvas: 'bpmn-canvas',
	bpmnExport: 'bpmn-export',
	bpmnExportMenu: 'bpmn-export-menu',
	modelRegenerate: 'model-regenerate',
	bpmnZoomIn: 'bpmn-zoom-in',
	bpmnZoomOut: 'bpmn-zoom-out',
	workspaceSwitcher: 'workspace-switcher',
	workspaceMembers: 'workspace-members',
	workspaceMembersAnchor: 'workspace-members-anchor',
} as const
